import React from 'react'
import { Form, Input, InputNumber, Switch, Modal, Button } from 'antd'
import _get from 'lodash/get'
import _uniq from 'lodash/uniq'
import mongoid from 'mongoid-js'
import Uploader from '~/components/Uploader'
import defaults from '~/data/defaults.json'
import initialValues from '~/data/initialValues.json'
import withRepeaterHandler from '~/utils/withRepeaterHandler'
import Error404 from '~/components/Error/404'
import { RepeaterItem } from '~/styles'
import config from '~/config'

import { withTranslation } from 'react-i18next'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 }
  }
}
const newFinisherShirtTypeId = mongoid()

@Form.create()
@withRepeaterHandler
class FinisherShirtTypeForm extends React.Component {
  state = {
    itemsDeletedIndexes: [],
    newFinisherShirtTypeId: false
  }
  confirmDelete = ({text, handleDelete}) => {
    Modal.confirm({
      title: 'Confirm delete',
      content: `Delete ${text} ?`,
      onOk: () => {
        handleDelete()
      },
      onCancel () {}
    })
  }
  removeFinisherShirt = this.props.removeItemHandler({ path: 'finisherShirts' })
  removeIndexItemHandler = this.props.removeIndexItemHandler({ path: 'finisherShirts' })
  removeFinisherShirtItem = (itemIndex) => {
    const {itemsDeletedIndexes} = this.state
    this.removeIndexItemHandler(itemIndex)
    itemsDeletedIndexes.push(itemIndex)
    this.setState({itemsDeletedIndexes: _uniq(itemsDeletedIndexes)})
  }
  getFinisherShirtTypes = this.props.getItemsHandler({ path: 'finisherShirtTypes' })
  getFinisherShirts = this.props.getItemsHandler({ path: 'finisherShirts' })
  addFinisherShirt = this.props.addItemHandler({ path: 'finisherShirts',
    defaultValues: defaults.shirts,
    initialValue: {
      ...initialValues.shirt,
      shirtTypeId: this.props.finisherShirtTypeId || newFinisherShirtTypeId
    }
  })
  render () {
    const { form, event, t } = this.props
    const { getFieldDecorator, getFieldValue } = form
    let shirtTypeId = this.props.finisherShirtTypeId || newFinisherShirtTypeId
    let finisherShirtTypes = getFieldValue('finisherShirtTypes') || [...(_get(event, 'finisherShirtTypes') || []),
      ...(this.props.finisherShirtTypeId ? [] : [{
        ...initialValues.shirtType,
        _id: shirtTypeId
      }])
    ]
    const finisherShirtType = finisherShirtTypes.find(s => s._id === shirtTypeId)

    if (shirtTypeId && !finisherShirtType) {
      return Error404
    }
    let finisherShirts = getFieldValue('finisherShirts') || [...(_get(event, 'finisherShirts') || []),
      ...(this.props.finisherShirtTypeId ? [] : defaults.shirts.map(s => {
        return {
          ...s,
          shirtTypeId
        }
      }))
    ]
    const { itemsDeletedIndexes } = this.state
    if (finisherShirts) {
      finisherShirts = finisherShirts.map((item, index) => {
        if (itemsDeletedIndexes.includes(index)) {
          item.__deleted = true
        }
        return item
      })
    }

    return <Form>
      <h3>{t('events.edit.shirt.type')}</h3>
      {finisherShirtTypes.map((finisherShirtType, finisherShirtTypeIndex) => {
        getFieldDecorator(`finisherShirtTypes[${finisherShirtTypeIndex}]._id`, {
          initialValue: _get(finisherShirtType, '_id') || mongoid()
        })
        let displayNone = shirtTypeId === finisherShirtType._id ? '' : 'displayNone'
        displayNone = finisherShirtType.__deleted ? 'displayNone' : displayNone
        return <RepeaterItem key={finisherShirtTypeIndex} deleted={finisherShirtType.__deleted} className={displayNone}>
          <Form.Item label={`${t('events.edit.shirt.typeName')} [EN]`} {...formItemLayout}>
            {getFieldDecorator(`finisherShirtTypes[${finisherShirtTypeIndex}].name.en`, {
              initialValue: _get(finisherShirtType, 'name.en'),
              rules: [{ required: true, message: 'Please enter shirt type [EN]' }]
            })(<Input />)}
          </Form.Item>
          <Form.Item label={`${t('events.edit.shirt.typeName')} [${config.default_locale.toUpperCase()}]`} {...formItemLayout} >
            {getFieldDecorator(`finisherShirtTypes[${finisherShirtTypeIndex}].name.${config.default_locale}`, {
              initialValue: _get(finisherShirtType, `name.${config.default_locale}`),
              rules: [{ required: true, message: `Please enter shirt type ${config.default_locale}` }]
            })(<Input />)}
          </Form.Item>
          <Form.Item {...formItemLayout} label={`${t('events.edit.shirt.url')}`}>
            {getFieldDecorator(`finisherShirtTypes[${finisherShirtTypeIndex}].imageUrl`, {
              initialValue: _get(finisherShirtType, 'imageUrl')
            })(
              <Uploader />
            )}
          </Form.Item>
          <hr/>
        </RepeaterItem>
      })}
      <h3>{t('events.edit.shirt.size')}</h3>
      {finisherShirts.map((finisherShirt, finisherShirtIndex) => {
        getFieldDecorator(`finisherShirts[${finisherShirtIndex}]._id`, {
          initialValue: finisherShirt._id
        })
        !getFieldValue(`temp.finisherShirts[${finisherShirtIndex}].limit`) &&
          getFieldDecorator(`finisherShirts[${finisherShirtIndex}].quantity`, {
            initialValue: null
          })
        let displayNone = shirtTypeId === finisherShirt.shirtTypeId ? '' : 'displayNone'
        displayNone = finisherShirt.__deleted ? 'displayNone' : displayNone
        getFieldDecorator(`finisherShirts[${finisherShirtIndex}].shirtTypeId`, {
          initialValue: _get(finisherShirt, 'shirtTypeId')
        })
        finisherShirt.__deleted && getFieldDecorator(`finisherShirts[${finisherShirtIndex}].__deleted`, {
          initialValue: true
        })
        return (
          <RepeaterItem key={finisherShirtIndex} deleted={finisherShirt.__deleted} className={displayNone}>
            <Button icon="delete" className="delete"
              onClick={() => this.confirmDelete({
                text: 'finisherShirt',
                handleDelete: () => this.removeFinisherShirtItem(finisherShirtIndex)})}
              style={{ position: 'absolute', right: 0, zIndex: 1 }}/>
            <Form.Item label={`${t('events.edit.shirt.sizeName')} [EN]`} {...formItemLayout}>
              {getFieldDecorator(`finisherShirts[${finisherShirtIndex}].name.en`, {
                initialValue: _get(finisherShirt, 'name.en'),
                rules: [{ required: true, message: 'กรุณากรอกชื่อไซส์เสื้อเป็นภาษาอังกฤษ' }]
              })(<Input />)}
            </Form.Item>
            <Form.Item label={`${t('events.edit.shirt.sizeName')} [${config.default_locale.toUpperCase()}]`} {...formItemLayout} >
              {getFieldDecorator(`finisherShirts[${finisherShirtIndex}].name.${config.default_locale}`, {
                initialValue: _get(finisherShirt, `name.${config.default_locale}`),
                rules: [{ required: true, message: 'กรุณากรอกชื่อไซส์เสื้อเป็นภาษาไทย' }]
              })(<Input />)}
            </Form.Item>
            {/* isLimit finisherShirt quantity */}
            <Form.Item label={`${t('events.edit.shirt.limit')}`} {...formItemLayout} >
              {getFieldDecorator(`temp.finisherShirts[${finisherShirtIndex}].limit`, {
                initialValue: _get(finisherShirt, 'quantity') !== null,
                valuePropName: 'checked'
              })(<Switch />)}
            </Form.Item>
            {/* if isLimit */}
            {getFieldValue(`temp.finisherShirts[${finisherShirtIndex}].limit`) && <Form.Item label={`${t('events.edit.shirt.quantity')}`} {...formItemLayout} >
              {getFieldDecorator(`finisherShirts[${finisherShirtIndex}].quantity`, {
                initialValue: _get(finisherShirt, 'quantity') == null ? 0 : _get(finisherShirt, 'quantity')
              })(<InputNumber min={0} />)}
            </Form.Item>}
            <hr/>
          </RepeaterItem>
        )
      })}
      <Form.Item wrapperCol={{ xs: { span: 24 }, sm: { span: 16, offset: 8 } } } >
        <Button className="create" icon="plus-circle" onClick={this.addFinisherShirt}>{t('events.edit.shirt.sizeAdd')}</Button>
      </Form.Item>
    </Form>
  }
}

export default withTranslation() (FinisherShirtTypeForm)
